import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Sharing from '../../../common/sharing/Sharing';
// import Button from '../../../common/button/Button';

class ShareComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showShare: false,
        };
    }

    render() {
        const artist = this.props.artist || 'Antena 1';
        const isNoMusic = this.props.metaType !== 'music';
        const song = this.props.song || 'A Rádio Online mais ouvida do Brasil';
        const title = isNoMusic ? 'o melhor do mundo da música' : `${song} de ${artist}`;
        const titleToShare = `Eu estou ouvindo ${title} na Antena 1`;
        const isMobile = this.props.isMobile;
        const artistHashtag = isNoMusic ? '' : artist.replace(' ', '');

        if (isMobile && !this.state.showShare) {
            return false;
        }

        return (
            <div className="share">
                {!isMobile &&
                    <div className={`${/* isMobile ? "balloonDialogueShare-mobile" : */'balloonDialogueShare'}`}>
                        <Sharing
                            path="/ouvir-radio-online"
                            iconSize={20}
                            widthBlockIcon={25}
                            shareButtonsTo={['facebook', 'twitter', 'whatsapp']}
                            facebook={{ quote: titleToShare, hashtag: '#Antena1' }}
                            twitter={{ title: titleToShare, hashtags: [artistHashtag, 'Antena1'] }}
                            whatsapp={{ title: titleToShare }}
                            directionContainer={`${'horizontal'}`}
                        />
                    </div>}
            </div>
        )
    }
}

ShareComponent.propTypes = exact({
    artist: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    song: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    metaType: PropTypes.string,
    isMobile: PropTypes.string,
});

export default ShareComponent;
